<!-- Desktop: Grid layout (md and above) -->
<section class="hidden md:flex bg-[#fafafa] border-b border-solid pb-6 mt-[80px] items-center h-48 lg:h-32 relative">
    <ul class="flex items-center flex-col md:flex-row gap-6 md:gap-0 md:flex-nowrap flex-grow">
        <li class="flex items-center gap-2 w-full justify-start md:w-auto md:flex-1 lg:flex-1">
            <img src="assets/images/footer.png" width="60" height="60" alt="رزرو 100 درصد آنلاین">
            <div class="flex flex-col gap-1 border-r-2 pr-2  border-solid border-metal-50">
                <p class="font-bold">رزرو 100 درصد آنلاین</p>
                <span class="text-muted text-sm">رزرو 100 درصد آنلاین بیش از 1900 هتل</span>
            </div>
        </li>
        <div class="hidden md:block w-px bg-gray-200 h-[60px] mx-[15px] flex-shrink-0"></div>
        <li class="flex items-center gap-2 w-full justify-start md:w-auto md:flex-1 lg:flex-1">
            <img src="assets/images/footer2.png" width="60" height="60" alt="مشاوره نیم میلیونی">
            <div class="flex flex-col gap-1 border-r-2 pr-2 border-solid border-metal-50">
                <p class="font-bold">مشاوره نیم میلیونی</p>
                <span class="text-muted text-sm">بزرگترین مرجع نظرات هتل ها</span>
            </div>
        </li>
        <div class="hidden md:block w-px bg-gray-200 h-[60px] mx-[15px] flex-shrink-0"></div>
        <li class="flex items-center gap-2 w-full justify-start md:w-auto md:flex-1 md:mt-0 lg:mt-0 lg:flex-1">
            <img src="assets/images/footer3.png" width="60" height="60" alt="گارانتی کمترین قیمت">
            <div class="flex flex-col gap-1 border-r-2 pr-2 border-solid border-metal-50">
                <p class="font-bold">گارانتی کمترین قیمت</p>
                <span class="text-muted text-sm">رزرو هتل با بیشترین تخفیف</span>
            </div>
        </li>

        
        <ng-container *ngIf="accommodation() !== 'ecolodge'">
            <div class="hidden md:block w-px bg-gray-200 h-[60px] mx-[15px] flex-shrink-0"></div>
            <li class="flex items-center gap-2 w-full justify-start md:w-auto md:flex-1 md:mt-0 lg:mt-0">
                <img src="assets/images/footer4.png" width="60" height="60" alt="کارمزد کنسلی رایگان">
                <div class="flex flex-col gap-1 border-r-2 pr-2 border-solid border-metal-50">
                    <p class="font-bold">کارمزد کنسلی رایگان</p>
                    <span class="text-muted text-sm">کارمزد کنسلی صفر درصد</span>
                </div>
            </li>
        </ng-container>
    </ul>
</section>

<!-- Mobile: Swiper layout (below md) -->
<div class="w-full md:hidden">
    <ng-container *ngIf="isBrowser && configSwiper">
        <swiper [config]="configSwiper">
            <ng-template swiperSlide>
                <div class="flex items-center gap-2 justify-start bg-[#fafafa] border border-solid border-gray-200 rounded-lg p-4">
                    <img src="assets/images/footer.png" width="50" height="50" alt="رزرو 100 درصد آنلاین">
                    <div class="flex flex-col gap-1 border-r-2 pr-2 border-solid border-metal-50">
                        <p class="font-bold text-sm">رزرو 100 درصد آنلاین</p>
                        <span class="text-muted text-xs">رزرو 100 درصد آنلاین بیش از 1900 هتل</span>
                    </div>
                </div>
                
            </ng-template>
            <ng-template swiperSlide>
                <div class="flex items-center gap-2 justify-start bg-[#fafafa] border border-solid border-gray-200 rounded-lg p-4">
                    <img src="assets/images/footer2.png" width="50" height="50" alt="مشاوره نیم میلیونی">
                    <div class="flex flex-col gap-1 border-r-2 pr-2 border-solid border-metal-50">
                        <p class="font-bold text-sm">مشاوره نیم میلیونی</p>
                        <span class="text-muted text-xs">بزرگترین مرجع نظرات هتل ها</span>
                    </div>
                </div>
            </ng-template>
            <ng-template swiperSlide>
                <div class="flex items-center gap-2 justify-start bg-[#fafafa] border border-solid border-gray-200 rounded-lg p-4">
                    <img src="assets/images/footer3.png" width="50" height="50" alt="گارانتی کمترین قیمت">
                    <div class="flex flex-col gap-1 border-r-2 pr-2 border-solid border-metal-50">
                        <p class="font-bold text-sm">گارانتی کمترین قیمت</p>
                        <span class="text-muted text-xs">رزرو هتل با بیشترین تخفیف</span>
                    </div>
                </div>
            </ng-template>
            <ng-template swiperSlide *ngIf="accommodation() !== 'ecolodge'">
                <div class="flex items-center gap-2 justify-start bg-[#fafafa] border border-solid border-gray-200 rounded-lg p-4">
                    <img src="assets/images/footer4.png" width="50" height="50" alt="کارمزد کنسلی رایگان">
                    <div class="flex flex-col gap-1 border-r-2 pr-2 border-solid border-metal-50">
                        <p class="font-bold text-sm">کارمزد کنسلی رایگان</p>
                        <span class="text-muted text-xs">کارمزد کنسلی صفر درصد</span>
                    </div>
                </div>
            </ng-template>
        </swiper>
    </ng-container>
</div>
